import gql from 'graphql-tag'

export const ADD_SHARED_MAILBOX = gql`
  mutation AddOutlookSharedMailbox($input: AddOutlookSharedMailboxInput!) {
    addOutlookSharedMailbox(input: $input)
  }
`

export const REMOVE_SHARED_MAILBOX = gql`
  mutation RemoveOutlookSharedMailbox(
    $input: RemoveOutlookSharedMailboxInput!
  ) {
    removeOutlookSharedMailbox(input: $input)
  }
`
